/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Contact1stdibsLink_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"TradeRepCircle_viewer">;
    readonly " $refType": "Contact1stdibsLink_viewer";
};
export type Contact1stdibsLink_viewer$data = Contact1stdibsLink_viewer;
export type Contact1stdibsLink_viewer$key = {
    readonly " $data"?: Contact1stdibsLink_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Contact1stdibsLink_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasTradeUserId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Contact1stdibsLink_viewer",
  "selections": [
    {
      "condition": "hasTradeUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "Defer",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TradeRepCircle_viewer"
            }
          ]
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'db9854a6602b7d952b66ee3fa88e6732';
export default node;
